<template>
  <div>
    <ed-table
    :key="$root.$session.versao"
      strModel="Cadastro/Usuario"
      :headers="arrayHeaders"
      :rows="arrayRows"
      :pagination="objPagination"
      :loading="loading"
      :filter="formFiltros"
      @register="onRegister"
      @edit="onEdit"
      @search="getEmpresa"
    />
  </div>
</template>

<script>
import { EdTable } from "@/components/common/form";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: { EdTable },
  mounted() {
    this.getEmpresa();
  },
  beforeDestroy() {
    this.arrayHeaders = [];
    this.arrayRows = [];
    this.objPagination = null;
  },
  created() {},
  data() {
    return {
      loading: false,
      arrayHeaders: [
        {
          text: "Nome",
          sortable: true,
          value: "strNome",
        },
        {
          text: "Login",
          sortable: true,
          collapse: 20,
          value: "strLogin",
        },
        {
          text: "CPF",
          sortable: true,
          value: "strCpf",
        },
        {
          text: "Email",
          sortable: true,
          value: "strEmail",
        },
        {
          text: "Tipo",
          sortable: true,
          value: "strTipoUsuario",
        },
        {
          text: "Último Acesso",
          sortable: true,
          value: "strDataUltimoAcesso",
        },
      ],
      arrayRows: [],
      objPagination: null,
      formFiltros:{}
    };
  },
  methods: {
    onRegister() {
      this.$router.push({ name: "cadastro.usuario.register" });
    },

    onDelete(arrayId) {
      console.log("onDelete", arrayId);
    },

    onEdit(data) {
      this.$router.push({
        name: "cadastro.usuario.edit",
        params: { intId: data.intId },
      });
    },

    getEmpresa() {
      this.loading = true;
      this.arrayRows = [];

      this.$root.$request
        .get("Cadastro/Usuario", this.formFiltros)
        .then((objResult) => {
          if (objResult.status == 200) {
            this.objPagination = objResult.result;
            this.loading = false;

            let arrayRows = [];

            objResult.result.data.forEach((objUsuario) => {
              let item = {
                intId: objUsuario.intId,
                strLogin: objUsuario.strLogin,
                strNome: objUsuario.strNome,
                strEmail: objUsuario.strEmail,
                strCpf: objUsuario.strCpf,
                strTipoUsuario: objUsuario.tipo_usuario
                  ? objUsuario.tipo_usuario.strNome
                  : "---",
                strDataUltimoAcesso: objUsuario.strDataUltimoAcesso
                  ? this.$utilidade.toDate(objUsuario.strDataUltimoAcesso)
                  : "---",
                _item: objUsuario,
              };

              arrayRows.push(item);
            });

            this.arrayRows = arrayRows;
          }
        });
    },
  },
};
</script>
